import { pushUrl } from 'libraries/front-end-core/core/history'
import url from 'libraries/front-end-core/core/url'
import { includes, trim } from 'libraries/lodash'
import {
  SET_SEARCH_PAGE_LIMIT,
  SET_SEARCH_PAGINATION_MODE,
  SET_SEARCH_PHRASE,
  SET_CURRENT_SEARCH_PHRASE,
  SET_SEARCH_QUERY,
  SET_SEARCH_RESULTS,
  SET_SEARCH_TYPE,
  SET_CURRENT_SEARCH_TYPE,
  SET_PAGINATION_PAGE_NUMBER,
  SET_SEARCH_RESPONSE,
  SET_SEARCH_TYPE_DISPLAY_NAME,
  SET_SEARCH_TYPE_CLASSES,
  SET_SEARCH_HELPER_VISIBLE,
  SET_SELECTED_AOLS
} from './types'
import {
  CURRENT_AWARENESS,
  MW_LIST_DEALS,
  LEGISLATION,
  QA_CONTENT,
  SEARCH,
  MW_OVERVIEW,
  SMART_SEARCH,
  DOCUMENTS_MENU
} from 'constants/controllers'
import { pushSearchHistory } from 'services/SessionService'
import { pushEvent } from 'services/AnalyticsService'
import { clear as searchClear } from 'services/InstantSearchService'
import menus from 'constants/menus'
import { SMART_SEARCH_ENABLED } from 'constants/storage-keys'
import { AppDispatch, RootState } from 'redux/store'
import { SearchState } from 'redux/reducers/search'
export const setSearchResults = (results: any): { type: typeof SET_SEARCH_RESULTS, results: any } => ({
  type: SET_SEARCH_RESULTS,
  results
})

export const setSearchPageLimit = (pageLimit: number): { type: typeof SET_SEARCH_PAGE_LIMIT, pageLimit: number } => ({
  type: SET_SEARCH_PAGE_LIMIT,
  pageLimit
})

export const setPaginationPageNumber = (pageNumber: number): { type: typeof SET_PAGINATION_PAGE_NUMBER, pageNumber: number } => ({
  type: SET_PAGINATION_PAGE_NUMBER,
  pageNumber
})

export const setSearchPaginationMode = (paginationMode: 'paged' | 'all'): { type: typeof SET_SEARCH_PAGINATION_MODE, paginationMode: 'paged' | 'all' } => ({
  type: SET_SEARCH_PAGINATION_MODE,
  paginationMode
})

export const setSearchQuery = (query: any): { type: typeof SET_SEARCH_QUERY, query: any } => ({
  type: SET_SEARCH_QUERY,
  query
})

export const setSearchPhrase = (searchPhrase: string) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_SEARCH_PHRASE,
      searchPhrase
    })
    dispatch(setCurrentSearchPhrase(searchPhrase))
  }
}

export const setCurrentSearchPhrase = (searchPhrase: string): { type: typeof SET_CURRENT_SEARCH_PHRASE, searchPhrase: string } => ({
  type: SET_CURRENT_SEARCH_PHRASE,
  searchPhrase
})

export const setSearchTypeDisplayName = (displayName: string): { type: typeof SET_SEARCH_TYPE_DISPLAY_NAME, displayName: string } => ({
  type: SET_SEARCH_TYPE_DISPLAY_NAME,
  displayName
})

export const setSearchTypeClasses = (searchTypeClasses: string): { type: typeof SET_SEARCH_TYPE_CLASSES, searchTypeClasses: string } => ({
  type: SET_SEARCH_TYPE_CLASSES,
  searchTypeClasses
})

export const setSearchHelperVisible = (searchHelperVisible: boolean): { type: typeof SET_SEARCH_HELPER_VISIBLE, searchHelperVisible: boolean } => ({
  type: SET_SEARCH_HELPER_VISIBLE,
  searchHelperVisible
})

export const setCurrentSearchType = (searchType: String) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_CURRENT_SEARCH_TYPE,
      searchType
    })
    const searchItem = menus.search.find(({ typeName }) => typeName === searchType)
    if (searchItem !== undefined) {
      const { title: displayName, activeClass: searchTypeClasses } = searchItem
      dispatch(setSearchTypeDisplayName(displayName))
      dispatch(setSearchTypeClasses(searchTypeClasses))
    }
  }
}

export const setSearchType = (searchType: string) => {
  return (dispatch: AppDispatch, _: any) => {
    dispatch({
      type: SET_SEARCH_TYPE,
      searchType
    })
    dispatch(setCurrentSearchType(searchType) as any)
  }
}

export const setSearchResponse = (response: any): { type: typeof SET_SEARCH_RESPONSE, response: any } => ({
  type: SET_SEARCH_RESPONSE,
  response
})

export const setSearchState = ({ pageLimit, pageNumber, paginationMode, query = {}, searchPhrase, searchType }: SearchState) => {
  return (dispatch: AppDispatch, _: any) => {
    if (pageLimit !== null && pageLimit !== undefined && pageLimit !== 0) dispatch(setSearchPageLimit(pageLimit))
    if (paginationMode !== null && paginationMode !== undefined) dispatch(setSearchPaginationMode(paginationMode))
    dispatch(setPaginationPageNumber(pageNumber))
    dispatch(setSearchQuery(query))
    if (searchPhrase !== null && searchPhrase !== undefined && searchPhrase !== '') dispatch(setSearchPhrase(searchPhrase) as any)
    if (searchType !== null && searchType !== undefined) dispatch(setSearchType(searchType) as any)
  }
}

export const submitSearchUpdate = ({ params, query }: { params: any, query: any }) => {
  return (_: any, getState: () => RootState) => {
    const {
      search,
      layout: { flavour, controller }
    } = getState()

    const { currentSearchPhrase, currentSearchType: searchType, paginationMode, smartSearchEnabled } = search
    const searchPhrase = trim(currentSearchPhrase)
    const pageNumber = paginationMode === 'all' ? 'all' : undefined
    const pathSource = (searchType === (MW_OVERVIEW as any) && includes(params.path, 'listdeals')) ? (params as { path?: string }) : {}
    const { path = 'listdeals/all' } = pathSource
    const aol = controller === SEARCH ? search.query?.aol : controller === SMART_SEARCH ? query?.aol : undefined
    const searchQuery = { q: searchPhrase, p: pageNumber, ...(aol !== undefined && aol !== null ? { aol: Array.isArray(aol) ? aol : [aol] } : {}) }
    const isSmartSearch = smartSearchEnabled && searchType === 'qa'
    const searchUrl = isSmartSearch
      ? url(SMART_SEARCH, { flavour }, { q: searchPhrase, ...(aol !== undefined && aol !== null ? { aol } : {}) })
      : url(SEARCH, { flavour: searchType === 'qa' ? flavour : undefined, pageNumber, searchPhrase, searchType }, searchQuery)

    const searchSwitch: Record<
    string,
    Record< 'type' | 'url', string >
    > = {
      [QA_CONTENT]: { type: `qa-${flavour.substr(0, 4)}`, url: searchUrl },
      [LEGISLATION]: { type: 'leg', url: searchUrl },
      dealwatch: {
        type: 'markets',
        url: url(MW_LIST_DEALS, { path }, { ...(query as Record<string, unknown> ?? {}), page: 1, q: searchPhrase, start: 0 })
      },
      [CURRENT_AWARENESS]: { type: 'ca', url: searchUrl },
      [DOCUMENTS_MENU]: { type: 'documents', url: searchUrl },
      marketplace: {
        type: 'marketplace',
        url: `https://www.fromcounsel.com/marketplace-search/?search=${searchPhrase}&filter=product&c_category=marketplace`
      }
    }

    if (currentSearchPhrase.length > 1) {
      const searching = searchSwitch[searchType]
      if (searching.type === 'marketplace') {
        window.location.href = searching.url
        return
      }

      pushSearchHistory(currentSearchPhrase, searching.type)
      pushEvent({
        action: 'Input',
        category: isSmartSearch ? 'Smart Search' : 'Search',
        label: `[${searching.type.toUpperCase()}] ${currentSearchPhrase}`
      })
      pushUrl(searching.url)
    } else if (currentSearchPhrase.length === 0) {
      searchClear()
    }
  }
}

export const setFilterAols = (aols: string[]): { type: typeof SET_SELECTED_AOLS, aols: string[] } => ({
  type: SET_SELECTED_AOLS,
  aols
})

export const setSmartSearchEnabled = (enabled: boolean) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const { user: { hasSmartFeatures } } = getState()
    if (hasSmartFeatures === true) {
      localStorage.setItem(SMART_SEARCH_ENABLED, JSON.stringify(enabled))
    }
    dispatch({
      type: 'SET_SMART_SEARCH_ENABLED',
      enabled
    })
  }
}
